import { Typewriter } from "react-simple-typewriter";
import SimpleImageSlider from "react-simple-image-slider";
import interestSvg from "../../../assets/Hobbies/interestSvg.png";




const HobbyInfoLayout = () => {

   

   
    const cinephile = [
      { url: "cinephile/6.jpg" },
      { url: "cinephile/2.jpg" },
      { url: "cinephile/3.jpeg" },
      { url: "cinephile/4.jpeg" },
    ];
    const gamer = [
      { url: "gamer/1.jpg" },
      { url: "gamer/2.jpg" },
      { url: "gamer/3.jpg" },
      { url: "gamer/4.jpeg" },
    ];
    const travel = [
      { url: "travel/1.jpg" },
      { url: "travel/2.jpg" },
      { url: "travel/3.jpg" },
      { url: "travel/4.jpg" },
      { url: "travel/5.jpg" },
    ];
    const foodie = [
      { url: "foodie/1.jpg" },
      { url: "foodie/2.jpg" },
      { url: "foodie/3.jpg" },
      { url: "foodie/4.jpeg" },
      { url: "foodie/5.jpeg" },
    ];

    return (
      <div className="HobbyInfoLayout-wrapper">
        <div className="wrapper">
          <div className="interest-svg-wrapper">
            <img src={interestSvg} alt="interestSvg" className="interest-svg" />
          </div>
        </div>
        <div className="typewritter-text-wrapper ">
          <h1 className="typewritter-text">
            I Love{" "}
            <span>
              <Typewriter
                words={[
                  "Games...",
                  "Movies...",
                  "Traveling...",
                  "Food...",
                  "Hanging out...",
                  "Technology...",
                ]}
                loop
                cursor
                cursorStyle="_"
                typeSpeed={80}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
          </h1>
        </div>
        <hr />
        <section className="hobby-section-wrapper">
          <section className="hobby-section">
            <h1>Cinephile</h1>
            <div className="hobby-list-and-image-wrapper">
              <div>
                {/* <h1>Cinephile</h1> */}
                <span className="hobby-list-wrapper">
                  <ul>
                    <li>
                      My most favourite Hobby is to watch movies/Tv
                      series/Anime.
                    </li>
                    <li>Love to talk/gossip about movie related issues.</li>
                    <li>
                      I have watched more than 2000 Movies, Series and Anime.
                      [According to my IMDB list]
                    </li>
                    <li>
                      My personal top 5 favourite movies are:{" "}
                      <ol>
                        <li>The Shawshank Redemption (1994)</li>
                        <li>It's a Wonderful Life (1946)</li>
                        <li>Zindagi na milegi dobara (2011)</li>
                        <li>Her (2013)</li>
                        <li>Your Name. (2016)</li>
                      </ol>
                    </li>
                    <li>
                      My personal top 5 favourite Tv series are:
                      <ol>
                        <li>Game of Thrones (2011 - 2019) </li>
                        <li>Breaking Bad (2008 - 2013)</li>
                        <li>Sherlock (2010 - 2017)</li>
                        <li>The Office (2005 - 2013)</li>
                        <li>The Big Bang Theory (2007 - 2019)</li>
                      </ol>
                    </li>
                    <li>
                      My personal top 5 favourite Anime series are:
                      <ol>
                        <li>Naruto (2002 - 2007) </li>
                        <li>Death Note (2006 - 2007) </li>
                        <li>Attack on Titan (2013 - 2022)</li>
                        <li>Fullmetal Alchemist: Brotherhood (2009 - 2012)</li>
                        <li>Haikyuu!! (2014 - 2020)</li>
                      </ol>
                    </li>
                  </ul>
                </span>
              </div>
              <div className="image-wrapper">
                <SimpleImageSlider
                  width={500}
                  height={300}
                  images={cinephile}
                  showBullets={true}
                  showNavs={true}
                  loop={true}
                  autoPlay={true}
                  autoPlayDelay={3}
                  slideDuration={0.2}
                />
              </div>
            </div>
          </section>
          <section className="hobby-section">
            <h1>Gamer</h1>
            <div className="hobby-list-and-image-wrapper">
              <div className="image-wrapper">
                <SimpleImageSlider
                  width={500}
                  height={300}
                  images={gamer}
                  showBullets={true}
                  showNavs={true}
                  loop={true}
                  autoPlay={true}
                  autoPlayDelay={3}
                  slideDuration={0.2}
                />
              </div>
              <div>
                {/* <h1>Cinephile</h1> */}
                <span className="hobby-list-wrapper">
                  <ul>
                    <li>
                      I love playing video games; mostly online-multiplayer
                      games with my friends.
                    </li>
                    <li>
                      I have played more than 5000 hours online since 2016
                      (according to my steam statistics).
                    </li>
                    <li>
                      {" "}
                      My personal top 5 favourite game [non-multiplayer]
                      franchises are:
                      <ol>
                        <li>Grand Theft Auto franchise </li>
                        <li>Batman: Arkham Knight franchise </li>
                        <li>Far Cry franchise</li>
                        <li>Red Dead Redemption franchise</li>
                        <li>god of war franchise</li>
                      </ol>
                    </li>
                    <li>
                      {" "}
                      My personal top 5 favourite online [multiplayer] games
                      are:{" "}
                      <ol>
                        <li>Paladins [3000+ playing time]</li>
                        <li>Pubg </li>
                        <li>Black Squad</li>
                        <li>Counter-Strike: Global Offensive</li>
                        <li>Valorant</li>
                      </ol>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </section>
          <section className="hobby-section">
            <h1>Traveler</h1>
            <div className="hobby-list-and-image-wrapper">
              <div>
                {/* <h1>Cinephile</h1> */}
                <span className="hobby-list-wrapper">
                  <ul>
                    <li>I love traveling and exploring.</li>
                    <li>
                      I had the opportunity to explore many places in Bangladesh
                    </li>
                    <li>
                      Some of my recent visited places are:
                      <ul>
                        <li>Shundarban</li>
                        <li>Saint Martin</li>
                        <li>Bandarban</li>
                        <li>Shajek</li>
                        <li>Tanguar Haor</li>
                      </ul>
                    </li>
                  </ul>
                </span>
              </div>
              <div className="image-wrapper">
                <SimpleImageSlider
                  width={500}
                  height={300}
                  images={travel}
                  showBullets={true}
                  showNavs={true}
                  loop={true}
                  autoPlay={true}
                  autoPlayDelay={3}
                  slideDuration={0.2}
                />
              </div>
            </div>
          </section>

          <section className="hobby-section">
            <h1>Foodie</h1>
            <div className="hobby-list-and-image-wrapper">
              <div className="image-wrapper">
                <SimpleImageSlider
                  width={400}
                  height={400}
                  images={foodie}
                  showBullets={true}
                  showNavs={true}
                  loop={true}
                  autoPlay={true}
                  autoPlayDelay={3}
                  slideDuration={0.2}
                />
              </div>
              <div>
                {/* <h1>Cinephile</h1> */}
                <span className="hobby-list-wrapper">
                  <ul>
                    <li>I love Food. You can call me a foodie.</li>
                    <li>
                      I love almost all types of foods with rare exceptions.
                    </li>
                    <li>
                      Some of my most favourite foods are:
                      <ul>
                        <li>Kachchi Biriyani</li>
                        <li>Mutton/Beef/Chicken Resala</li>
                        <li>Chicken/Beef Chaap</li>
                        <li>Pizza</li>
                        <li>Pasta</li>
                      </ul>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </section>
        </section>
      </div>
    );
}

export default HobbyInfoLayout;